var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatSubmit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 6.66667,
    fill: "#007AFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "translate(10 10)",
    fill: "#007AFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0414 12.0943C20.9047 11.9571 20.7423 11.8483 20.5634 11.774C20.3846 11.6998 20.1928 11.6615 19.9992 11.6615C19.8055 11.6615 19.6138 11.6998 19.4349 11.774C19.2561 11.8483 19.0936 11.9571 18.9569 12.0943L14.0522 16.999C13.7758 17.2754 13.6205 17.6503 13.6205 18.0412C13.6205 18.4322 13.7758 18.8071 14.0522 19.0835C14.3287 19.3599 14.7036 19.5152 15.0945 19.5152C15.4854 19.5152 15.8603 19.3599 16.1367 19.0835L18.529 16.6912L18.529 26.8684C18.529 27.2587 18.684 27.6329 18.9599 27.9089C19.2359 28.1848 19.6101 28.3398 20.0004 28.3398C20.3906 28.3398 20.7649 28.1848 21.0408 27.9089C21.3168 27.6329 21.4718 27.2587 21.4718 26.8684L21.4718 16.6912L23.864 19.081C24.0009 19.2179 24.1634 19.3265 24.3422 19.4005C24.5211 19.4746 24.7127 19.5127 24.9063 19.5127C25.2972 19.5127 25.6721 19.3575 25.9485 19.081C26.0854 18.9442 26.194 18.7817 26.2681 18.6028C26.3421 18.424 26.3802 18.2324 26.3802 18.0388C26.3802 17.6479 26.225 17.273 25.9485 16.9965L21.0414 12.0943Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatSubmit);
export default __webpack_public_path__ + "static/media/chatSubmit.5fc56e538111d40fc6f39aa37f568769.svg";
export { ForwardRef as ReactComponent };